import { StyledModal } from '@app/components/modal/Modal';
import useNumberActions from '@app/hooks/numbers/useNumberActions';
import type { AINumber } from '@app/services/api.types';
import type { ModalProps } from 'antd';

export type AgentDeleteModalProps = ModalProps & {
    title?: string;
    data?: AINumber;
};

export const AgentDeleteModal = ({ title, data, ...props }: AgentDeleteModalProps) => {
    const { deleteNumber } = useNumberActions();

    const isUnassigned = !data?.location_id;
    const modalTitle = title ?? (isUnassigned ? 'Delete AI Agent Number?' : 'Delete Ai Agent?');
    const confirmMessage = isUnassigned
        ? 'Are you sure you want to remove this AI Agent Number?'
        : 'Are you sure you want to remove this AI agent?';

    return (
        <StyledModal
            title={modalTitle}
            mask={{ closable: false }}
            okText="Delete"
            {...props}
            confirmLoading={deleteNumber?.isPending}
            onOk={(e) => {
                const formData = { id: data?.id || 0 };
                deleteNumber.mutate(formData, {
                    onSuccess: () => {
                        if (props?.onOk) {
                            props.onOk(e);
                        }
                    },
                });
            }}>
            <p>{confirmMessage}</p>
        </StyledModal>
    );
};

export default AgentDeleteModal;
